import React from 'react';
import products from '../content/products';

export default function Products() {
  return (
    <section id="products" className="py-16 px-6 text-white text-center">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-8">Products</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left text-gray-300">
          {products.map((module, idx) => (
            <div
              key={idx}
              className={`${module.title === 'Analytics' ? 'md:col-span-2' : ''} bg-gray-900 border border-gray-700 rounded-xl p-6 shadow-md flex flex-col items-start gap-4`}
            >
              <i className={`${module.iconClass} text-4xl text-blue-400`} />
              <h3 className="text-xl font-semibold text-white">
                {module.title}
              </h3>
              <p className="text-gray-300 text-sm">{module.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
